import { useTranslation } from 'react-i18next';
import { Container } from './styles';

import emptyImg from 'Static/images/empty-comments.png';

const Empty = () => {
  const { t } = useTranslation('activities');
  return (
    <Container>
      <img src={emptyImg} alt="" />
      <span className="title">{t('empty.noCommentsTitle')}</span>
      <span className="description">
        {t('empty.noComments')}
      </span>
    </Container>
  )
}

export default Empty;
